<template>
  <svg
    :width="viewWidth"
    :height="viewHeight"
    :viewBox="`0 0 ${viewWidth} ${viewHeight}`"
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
  >
    <slot/>
  </svg>
</template>

<script>
export default {
  props: {
    viewWidth: {
      type: Number,
      default: 0,
    },
    viewHeight: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
}
</style>
